import { useCallback, useEffect, useMemo, useState } from "react";

import { ApiEndpoints, ApiResponse, getApiClient } from "../../../api-http";
import { getApiLocale } from "../../../api-http/get-api-locale";
import { useLocaleContext } from "../../../i18n/locale-context";
import { JobData } from "../types";

export function useGetJobDetail(id: string | null) {
  const { locale } = useLocaleContext();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<JobData | null>(null);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    const apiLocale = getApiLocale(locale);
    if (!id) return;

    setLoading(true);

    try {
      const response = await getApiClient().get<ApiResponse<JobData>>(
        `${ApiEndpoints.JOB_POSITIONS}/${id}`,
        { headers: { "Accept-Language": apiLocale } }
      );
      setData(response.data.data);
    } catch (e: any) {
      setError(e.hasOwnProperty("message") ? e.message : e.toString());
    }

    setLoading(false);
  }, [id, locale]);

  useEffect(() => {
    if (id) fetchData();
  }, [fetchData, id]);

  return useMemo(
    () => ({
      data,
      loading,
      error,
    }),
    [data, loading, error]
  );
}
